import React from 'react';
import { Modal, CustomModalLayout } from '@wix/design-system';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { ProfilePageType } from '@common/types';
import BriefContactStatusModalContentFail from '../BriefContactStatusModalContentFail';
import BriefContactStatusModalContentSuccess from '../BriefContactStatusModalContentSuccess';
import MyProjectsLink from '../MyProjectsLink';

const dataHooks = {
  modalDesktopLayout: 'brief-contact-status-modal-desktop-layout',
};

type Props = {
  contactStatus: 'success' | 'error';
  clearStatus: () => void;
};

const BriefContactStatusModalDesktop = ({
  contactStatus,
  clearStatus,
}: Props) => {
  const { profilePageType } = useProfileContext();

  const isSuccess = contactStatus === 'success';
  const showMyProjectsLink =
    isSuccess && profilePageType === ProfilePageType.MARKETPLACE;

  return (
    <Modal isOpen={true} onRequestClose={clearStatus}>
      <CustomModalLayout
        dataHook={dataHooks.modalDesktopLayout}
        width="600px"
        onCloseButtonClick={clearStatus}
        content={
          isSuccess ? (
            <BriefContactStatusModalContentSuccess />
          ) : (
            <BriefContactStatusModalContentFail onClickTryAgain={clearStatus} />
          )
        }
        footnote={
          showMyProjectsLink ? <MyProjectsLink textSize="small" /> : null
        }
      />
    </Modal>
  );
};

export default BriefContactStatusModalDesktop;
